import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatDialog } from '@angular/material/dialog'
import { MatDialogModule } from '@angular/material/dialog'
import { MatInputModule } from '@angular/material/input'
import { HttpClient, HttpClientModule } from '@angular/common/http'
import { HomeService } from '../home.service'
import { NgForm } from '@angular/forms'
import { FormsModule } from '@angular/forms'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { InputComponent } from '../../input/input.component'
import { from } from 'rxjs'
import { Router } from '@angular/router'
@Component({
  selector: 'app-form-pesan',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    InputComponent,
    MatProgressSpinnerModule,
    FormsModule,
    MatInputModule,
    HttpClientModule,
    MatSnackBarModule,
  ],
  providers: [HomeService],
  template: `
  <!-- <mat-dialog-container style="width: 450px;"> -->

    <h1 mat-dialog-title class="text-sm">Type Your Invitation</h1>
    <div *ngIf="isSucces" class="bg-indigo-900 text-center py-4 lg:px-4 mb-5 rounded ">
      <div
        class="p-2 bg-indigo-800 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex"
        role="alert"
      >
        <span
          class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3"
        >
          OK
        </span>
        <span class="font-semibold mr-2 text-left flex-auto">
          Success Send Message, Thank You !
        </span>
      </div>
    </div>
    <div>
      <form
        #f="ngForm"
        (ngSubmit)="doSendToHire(f)"
        class="example-form grid grid-rows-2"
      >
        <mat-form-field class="example-full-width">
          <mat-label>Email</mat-label>
          <input
            name="email"
            required
            ngModel
            matInput
            placeholder="pt@ptname.com"
          />
          <!-- <app-input></app-input> -->
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>NumberPhone</mat-label>
          <input
            name="numberPhone"
            required
            ngModel
            matInput
            placeholder="0857+++++++++"
          />
          <!-- <app-input></app-input> -->
        </mat-form-field>
        <mat-form-field class="example-full-width">
          <mat-label>Company Name</mat-label>
          <input
            name="companyName"
            required
            ngModel
            matInput
            placeholder="Ex. PT Inovation"
          />
          <!-- <app-input></app-input> -->
        </mat-form-field>

        <mat-form-field class="example-full-width">
          <mat-label>Leave simple message</mat-label>
          <textarea
            class="text-sm"
            type="text"
            name="message"
            ngModel
            required
            matInput
            placeholder="Ex. Hi Angga We are From PT Inovation..."
          ></textarea>
        </mat-form-field>
        <div class="grid grid-cols-2 gap-1">
          <div mat-dialog-actions>
            <button
              type="submit"
              class="cursor-not-allowed inline-block px-6 py-2 bg-blue-500 active:bg-blue-500 text-white font-medium text-xs rounded focus:bg-blue-400 focus:shadow-lg"
              [disabled]="!f.valid"
            >
              <span *ngIf="!isLoading">
                Ya Send
              </span>
              <mat-spinner
                [style.color]="'white'"
                *ngIf="isLoading"
                diameter="20"
                style="color:white"
              ></mat-spinner>
            </button>
          </div>

          <div mat-dialog-actions>
            <button
              class="cursor-not-allowed inline-block px-6 py-2 bg-green-500 active:bg-blue-500 text-white font-medium text-xs rounded focus:bg-blue-400 focus:shadow-lg"
              [disabled]="!f.valid"
              *ngIf="isAdmin"
              (click)="doDownloadCv()"
            >
              <span *ngIf="!isLoading">
                Liat CV
              </span>
              <mat-spinner
                [style.color]="'white'"
                *ngIf="isLoading"
                diameter="20"
                style="color:white"
              ></mat-spinner>
            </button>
          </div>
        </div>
      </form>
    </div>

  <!-- </mat-dialog-container> -->
  `,
  styleUrls: ['form-pesan.component.scss'],
})
export class FormPesanComponent implements OnInit {
  isLoading = false
  isSucces = false;
  inputName = 'test aja'
  isAdmin = false;
  inputType = 'text'
  @Input() companyName: any
  @Input() message: any
  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private homeService: HomeService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  doSendToHire(form: NgForm) {
    this.isLoading = true
    const bodyForm = {
      email: form.value.email,
      numberPhone: form.value.numberPhone,
      companyName: form.value.companyName,
      message: form.value.message,
    }
    console.log(bodyForm)
    this.homeService.doSendHire(bodyForm).subscribe(
      (value: any) => {
        this.isLoading = false
        this.isSucces = true,
        form.value.email = ''
        form.value.numberPhone = ''
        form.value.companyName = ''
        form.value.message = ''
        setTimeout(() => {
          this.isSucces = false;
          this.router.navigateByUrl('/')
        }, 5000);
      },
      (error) => {
        this.isLoading = false
        console.log(error)
      },
    )
  }
  doDownloadCv() {
    this.homeService.downloadPdfCv().subscribe((response: any) => {
      const file = new Blob([response], { type: 'application/pdf' })
      const fileUrl = URL.createObjectURL(file)
      window.open(fileUrl)
    })
  }
}
